/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tokens_OnceInputs */

const en_tokens_once = /** @type {(inputs: Tokens_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy the token into the Shortcut now – it is shown only once.`)
};

const de_tokens_once = /** @type {(inputs: Tokens_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiere das Token jetzt in den Kurzbefehl – es wird nur einmal angezeigt.`)
};

/**
* | output |
* | --- |
* | "Copy the token into the Shortcut now – it is shown only once." |
*
* @param {Tokens_OnceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tokens_once = /** @type {((inputs?: Tokens_OnceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tokens_OnceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tokens_once(inputs)
	return en_tokens_once(inputs)
});